import api from "../api/api";

// Get all products in a category
export const getProductsByCategory = async (categoryId) => {
  try {
    const response = await api.get(`products/category/${categoryId}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching products by category:", error);
    throw error;
  }
};

// Get single product details
export const getSingleProduct = async (productId) => {
  try {
    const response = await api.get(`web/products/${productId}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

// Get all products
export const getAllProducts = async () => {
  try {
    const response = await api.get("web/products");
    return response.data.data;
  } catch (error) {
    console.error("Error fetching all products:", error);
    throw error;
  }
};

// Mock: get reviews (in production, replace with real API)
export const getProductReviews = async (productId) => {
  return Promise.resolve([
    // { id: 1, name: "John Doe", rating: 5, comment: "Fantastic product!" },
    // { id: 2, name: "Alice Smith", rating: 4, comment: "Very good, worth it!" },
  ]);
};

export const getNewArrivals = async () => {
  try {
    const response = await api.get("web/new-arrivals-products");
    return response.data.data;
  } catch (error) {
    console.error("Error fetching new arrivals:", error);
    throw error;
  }
};

export const getBestSellers = async () => {
  try {
    const response = await api.get("web/best-sellers-products");
    return response.data.data;
  } catch (error) {
    console.error("Error fetching best sellers:", error);
    throw error;
  }
};

// ✅ Get Trending Products
export const getTrendingProducts = async () => {
  try {
    const response = await api.get("web/trending-products");
    return response.data.data;
  } catch (error) {
    console.error("Error fetching trending products:", error);
    throw error;
  }
};

// Search products
export const searchProducts = async (query) => {
  try {
    const response = await api.get(`web/products?search=${encodeURIComponent(query)}`);
    return response.data.data;
  } catch (error) {
    console.error("Error searching products:", error);
    throw error;
  }
};